import { useQuery } from "@tanstack/react-query";
import { api, API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { secureClick } from "@/lib/openFile";
import { monthLabel } from "@/components/MonthPicker";
import { FileDown } from "lucide-react";
import { useProvince } from "@/components/ProvinciaSelect";

export function DistaccamentoFilter({ value, onChange, testid, allLabel = "Tutti i distaccamenti" }) {
  const { data: distaccamenti = [] } = useQuery({ queryKey: ["distaccamenti"], queryFn: async () => (await api.get("/guardie/distaccamenti")).data });
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[250px]" data-testid={testid}><SelectValue placeholder="Distaccamento" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="tutti">{allLabel}</SelectItem>
        {distaccamenti.map((d) => <SelectItem key={d} value={d}>{d}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function ProvinciaFilter({ value, onChange, testid }) {
  const { data: province = [] } = useProvince();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[220px]" data-testid={testid}><SelectValue placeholder="Provincia" /></SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value="tutte">Tutte le province</SelectItem>
        <SelectItem value="__nessuna__">Senza provincia</SelectItem>
        {province.map((p) => <SelectItem key={p.sigla} value={p.sigla}>{p.nome} ({p.sigla})</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function RiepilogoPdfButton({ mese, distaccamento, provincia, testid }) {
  const qs = new URLSearchParams({ mese });
  if (distaccamento && distaccamento !== "tutti") { qs.set("distaccamento", distaccamento); }
  if (provincia && provincia !== "tutte") { qs.set("provincia", provincia); }
  const url = `${API}/riepilogo-mensile/pdf?${qs.toString()}`;
  return (
    <Button variant="outline" asChild>
      <a href={url} onClick={secureClick(url)} target="_blank" rel="noopener noreferrer" data-testid={testid}>
        <FileDown className="mr-2 h-4 w-4 text-red-700" /> Riepilogo {monthLabel(mese)}{provincia && provincia !== "tutte" ? ` · ${provincia === "__nessuna__" ? "senza prov." : provincia}` : ""}{distaccamento && distaccamento !== "tutti" ? ` · ${distaccamento}` : ""} (PDF)
      </a>
    </Button>
  );
}
